import { render } from "./EditModuleConfiguration.vue?vue&type=template&id=76bce9b6&scoped=true"
import script from "./EditModuleConfiguration.vue?vue&type=script&lang=js"
export * from "./EditModuleConfiguration.vue?vue&type=script&lang=js"

import "./EditModuleConfiguration.vue?vue&type=style&index=0&id=76bce9b6&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bce9b6"]])

export default __exports__